import type { EventPayload, Tagging, TaggingConfig } from './types';

/**
 * `createTagging`. `creative-ui` has no equivalent, so this reimplements the
 * minimal subset of `@engie/web-components`'s tagging API used by this app.
 */
export function createTagging(config: TaggingConfig): Tagging {
  let context = config.defaultContext ?? {};

  function track(name: string, payload?: EventPayload) {
    const event = {
      name,
      payload,
      context,
      timestamp: Date.now(),
    };

    for (const adapter of config.adapters) {
      try {
        adapter.track(event);
      } catch {
        console.error('Could not track event: ', event);
      }
    }
  }

  return {
    track,
    pageView(payload) {
      track('onload', payload);
    },
    onClick(payload) {
      track('onclick', payload);
    },
    onModal(payload) {
      track('onmodal', payload);
    },
    addContext(ctx) {
      context = { ...context, ...ctx };
    },
    removeContextKey(key) {
      const { [key]: _removed, ...rest } = context;
      context = rest;
    },
  };
}
